<template>
  <div class="stat-card">
    <div class="stat-icon">
      <img 
          :src="getIconPath(icon)" 
          :alt="iconAlt"
          class="stat-icon-image"/>
    </div>
    <div class="stat-number">{{ number }}</div>
    <div class="stat-desc">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    icon: {
      type: String,
      required: true
    },
    iconAlt: {
      type: String,
      default: 'Stat Icon'
    },
    number: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
      getIconPath(iconName) {
        // 动态导入图片
        try {
          return require(`@/assets/${iconName}`)
        } catch (error) {
          console.warn(`Icon not found: ${iconName}`, error)
          // 返回一个默认图标或空字符串
          return ''
        }
      }
    }
}
</script>

<style scoped>
.stat-card {
  text-align: left;
  padding: 30px 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: rgba(255, 255, 255, 0.08);
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 100px;
  margin-bottom: 15px;
  padding: 10px;
  max-width: 50px;
  max-height: 50px;
}
.stat-icon-image {
  max-width: 30px;
  max-height: 30px;
  object-fit: contain;
}
.stat-number {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
}

.stat-desc {
  font-size: 16px;
  color: white;
  line-height: 1.4;
}
</style>